export const Permissions = {
  BasicAcces:{ id: 'basicAccess', code : 100, display : "permissions.basicAccess", shortDisplay : "BAC" },
  Administration: {id: 'administration', code: 900, display: "permissions.administration", shortDisplay: "ADM"},
}
